/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 用户/用户组
 */
export interface UserOrGroup {
    /**
     * ID。
     * 本地用户/用户组为接口返回的ID字段
     * 域用户/用户组由名称和类型拼成
     */
    id?: string;
    DOMAINTYPE?: DomainTypeE;
}

/**
 * 用户类型
 * 0 Everyone
 * 1 本地用户
 * 2 本地用户组
 * 3 AD域用户
 * 4 AD域用户组
 * 5 DataTurbo用户
 * 6 Unix本地用户
 * 7 Unix本地认证组
 * 8 LDAP域用户
 * 9 LDAP域组
 * 10 NIS域用户
 * 11 NIS域组
 */
export enum UserTypeE {
    Everyone = 0,
    User = 1,
    UserGroup = 2,
    AD = 3,
    ADGroup = 4,
    DataTurbo = 5,
    UnixUser = 6,
    UnixUserGroup = 7,
    Ldap = 8,
    LdapGroup = 9,
    Nis = 10,
    NisGroup = 11
}

/**
 * root权限限制。
 * 0：读
 *
 * 1：完全控制
 *
 * 2：禁止
 *
 * 5：读、写
 */
export enum CIFSUserPermissionsE {
    Read = 0,
    All = 1,
    No = 2,
    ReadAndWrite = 5
}

/**
 * 域类型
 * 0 AD域用户/组
 * 1 LDAP域用户/组
 * 2 本地用户/组
 * 3 NIS域用户/组
 * 4 UNIX用户/组
 */
export enum DomainTypeE {
    AD = 0,
    Ldap = 1,
    Local = 2,
    Nis = 3,
    Unix = 4
}

/**
 * 名称类型
 */
export enum AuthNameE {
    /**
     * Everyone
     */
    Everyone = 0,
    /**
     * 用户
     */
    Single = 1,
    /**
     * 用户组
     */
    Group = 2
}

export function prefixHandler(name: string): string {
    if (name.charAt(0) === '@') {
        return name.substr(1);
    }
    return name;
}
